import Accordion from 'components/shared/accordion/Accordion';
import { AccordionItemProps } from 'components/shared/accordion/Accordion.types';
import HtmlTrans from 'components/shared/HtmlTrans';
import { TFunction } from 'hooks/useI18n';
import MethodologyExperience from './charts/MethodologyExperience';
import MethodologyGender from './charts/MethodologyGender';
import MethodologyRoles from './charts/MethodologyRoles';
import { MethodologySectionProps } from './Methodology.types';

const genderAccordion = (t: TFunction): AccordionItemProps[] => [
  {
    summary: t('mantechcar24.methodology.gender.api-title'),
    details: (
      <HtmlTrans
        ns="developer-career-report-2024"
        i18nKey="mantechcar24.methodology.gender.api-content"
      />
    )
  },
  {
    summary: t('mantechcar24.methodology.gender.question-title'),
    details: (
      <HtmlTrans
        ns="developer-career-report-2024"
        i18nKey="mantechcar24.methodology.gender.question-content"
      />
    )
  }
];

export const METHODOLOGYSECTIONS = (
  t: TFunction
): MethodologySectionProps[] => [
  {
    title: t('mantechcar24.methodology.experience.title'),
    desc: 'mantechcar24.methodology.experience.desc',
    chart: <MethodologyExperience />
  },
  {
    title: t('mantechcar24.methodology.roles.title'),
    desc: 'mantechcar24.methodology.roles.desc',
    chart: <MethodologyRoles />
  },
  {
    title: t('mantechcar24.methodology.gender.title'),
    desc: 'mantechcar24.methodology.gender.desc',
    chart: <MethodologyGender />,
    accordion: <Accordion items={genderAccordion(t)} />
  }
];
